export default function siteNavigation() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header');
  menuToggle.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true' || false;
    this.setAttribute('aria-expanded', !expanded);
    nav.classList.toggle('header__nav--open');
  });

  let lastScrollY = window.scrollY;

  window.addEventListener(
    'scroll',
    function () {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        nav.classList.add('scrolled');
      } else if (currentScrollY < lastScrollY) {
        nav.classList.remove('scrolled', 'header__home-hidden');
      }

      if (currentScrollY < window.innerHeight) {
        nav.classList.add('header__home-hidden');
      } else {
        nav.classList.remove('header__home-hidden');
      }

      lastScrollY = currentScrollY;
    },
    { passive: true },
  );
}
